import type { Recipe } from '../../types'
import { image, ingredient, scaled, section, peopleScaler } from '../helpers'

export const caviarAubergines: Recipe = {
  slug: 'caviar-aubergines',
  title: 'Caviar d’aubergines',
  category: 'salé',
  description: 'Une recette douce et fondante, à servir tiède ou froide.',
  image: image('caviar-aubergines'),
  tags: ['aubergine', 'air fryer', 'tartinade'],
  scaler: peopleScaler(2),
  meta: [
    { label: 'Préparation', value: '10 à 15 min' },
    { label: 'Cuisson aubergines', value: 'air fryer 200 °C, 12 à 18 min' },
    { label: 'Repos', value: '5 à 10 min pour égoutter la chair si besoin' },
  ],
  sections: [
    section('Ingrédients', [
      scaled('aubergine', 'aubergine', 1, 'grosse aubergine', {
        pluralUnit: 'grosses aubergines',
        shoppingKey: 'aubergine',
      }),
      scaled('huile', 'huile d’olive', 20, 'g', {
        display: '20 g (≈ 1 1/2 c. à soupe) d’huile d’olive',
      }),
      scaled('citron', 'jus de citron', 10, 'g', {
        display: '10 g (≈ 2 c. à café) de jus de citron',
      }),
      scaled('sel', 'sel fin', 2, 'g', { display: '2 g de sel fin' }),
    ]),
    section('Option', [
      scaled('ail', 'ail', 1, 'petite gousse d’ail', {
        pluralUnit: 'petites gousses d’ail',
        optional: true,
        shoppingKey: 'ail',
      }),
      scaled('cumin', 'cumin moulu', 0.5, 'g', {
        display: '0,5 g (≈ 1/4 c. à café rase) de cumin moulu',
        optional: true,
      }),
      ingredient(
        'conseil-ail',
        'ail',
        'Le caviar fonctionne très bien sans ail. Si vous en mettez, commencer avec une demi-gousse puis ajuster après avoir goûté.',
        { optional: true },
      ),
    ]),
  ],
  steps: [
    'Couper l’aubergine en deux dans la longueur. Quadriller légèrement la chair, badigeonner d’un peu d’huile, puis cuire à l’air fryer à 200 °C pendant 12 à 18 minutes. Commencer à vérifier dès 10 minutes : la chair doit être très fondante et légèrement dorée.',
    'Laisser tiédir, récupérer la chair à la cuillère puis la laisser s’égoutter 5 à 10 minutes si elle paraît très humide.',
    'Écraser la chair à la fourchette ou la mixer très brièvement, puis ajouter l’huile d’olive, le jus de citron, le sel, et éventuellement l’ail finement râpé ou pressé ainsi que le cumin.',
    'Mélanger, goûter et ajuster le citron et le sel. Si vous utilisez de l’ail, mieux vaut l’ajouter progressivement.',
    'Laisser reposer 10 minutes avant de servir, de préférence à température ambiante, avec du pain grillé ou comme accompagnement.',
  ],
  note: 'Les grammes sont la référence. Les équivalences en cuillères sont là pour se repérer rapidement.',
}
